import { toast } from "react-toastify";


export function formatDateForExport(isoDate) {
    const date = new Date(isoDate);
    return date.toLocaleDateString('fr-FR');
}

// Fonction pour exporter en Excel
export const exportToExcel = (headers, excelData, filename = 'fichierExcel.xlsx') => {
    try {
        const csvContent = [
            headers.join('\t'),
            ...excelData.map(row => row.join('\t'))
        ].join('\n');

        // Créer un fichier TSV (tab-separated values) pour Excel
        const blob = new Blob([csvContent], { type: 'application/vnd.ms-excel;charset=utf-8' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);

        console.log(`Export Excel réussi: ${excelData.length} clients`);
        toast.success(`Export Excel réussi: ${excelData.length} clients`);
    } catch (error) {
        console.error('Erreur lors de l\'export Excel:', error);
        toast.error('Erreur lors de l\'export Excel');
    }
};


// Fonction pour exporter en CSV
export const exportToCSV = (headers, csvData, filename = 'clients.csv') => {

    try {
        // Créer le contenu CSV
        const csvContent = [
            headers.join(','),
            ...csvData.map(row => row.map(field => `"${field}"`).join(','))
        ].join('\n');

        // Créer et télécharger le fichier
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);

        console.log(`Export CSV réussi: ${csvData.length} `);
        toast.success(`Export CSV réussi: ${csvData.length} `);
    } catch (error) {
        console.error('Erreur lors de l\'export CSV:', error);
        toast.error("Erreur lors de l'export CSV");
    }
};